import "./Home.css";
import profileimg from "../Assets/Images/dp-profile.jpg";
import { useRef, useEffect, useState, useContext } from "react";
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { UserContext } from "../App";

const Header = () => {
  const btnRef = useRef(null);
  const [click, setClick] = useState(false);
  const [profile, setProfile] = useState(null);
  const { theme, toggleTheme } = useContext(UserContext);

  useEffect(() => {
    if (click) {
      btnRef.current.parentNode.classList.add("mobile-nav-active");
    } else {
      btnRef.current.parentNode.classList.remove("mobile-nav-active");
    }
  }, [click]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data, error } = await supabase
          .from('about')
          .select('*')
          .single();
        if (data) setProfile(data);
      } catch (e) {
        console.error(e);
      }
    };
    fetchProfile();
  }, []);

  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'about', 'resume', 'portfolio'];
      const scrollPosition = window.scrollY + 300; // Offset for better triggering

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section === 'hero' ? 'home' : section);
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const data = profile || {
    full_name: "Devaprasad",
    profile_image: profileimg,
    social_links: {
      twitter: "https://twitter.com/n_devaprasad",
      whatsapp: "tel:8547198697",
      instagram: "https://www.instagram.com/devaprasadmohanan/",
      github: "https://github.com/devaprasadnm",
      linkedin: "https://www.linkedin.com/in/devaprasad-n-m-3a6b15197/"
    }
  };

  const social = data.social_links || {};

  return (
    <>
      <i
        ref={btnRef}
        className={
          click
            ? "bi bi-list mobile-nav-toggle d-xl-none bi-x"
            : "bi bi-list mobile-nav-toggle d-xl-none bi-list"
        }
        onClick={() => setClick(!click)}
      ></i>

      <header id="header">
        <div className="d-flex flex-column">
          <div className="profile">
            <img src={data.profile_image || profileimg} alt="" className="img-fluid rounded-circle" data-aos="fade-in" />
            
            <h1 className="text-light">
              <a href="index.html">{data.full_name || "Devaprasad"}</a>
            </h1>

            <div className="text-center mt-2">
              <button 
                className={`btn btn-sm rounded-pill ${theme === 'light' ? 'btn-outline-light' : 'btn-outline-warning'}`} 
                onClick={toggleTheme}
                style={{ fontSize: '0.8rem' }}
              >
                {theme === 'light' ? <i className="bx bx-moon"></i> : <i className="bx bx-sun"></i>} 
                {theme === 'light' ? ' Dark' : ' Light'}
              </button>
            </div>
           
            <div className="social-links mt-3 text-center" data-aos="fade-in" data-aos-delay="100">
              {social.twitter && <a href={social.twitter} className="twitter"><i className="bx bxl-twitter"></i></a>}
              {social.whatsapp && <a href={social.whatsapp} className="facebook"><i className="bx bxl-whatsapp"></i></a>}
              {social.instagram && <a href={social.instagram} className="instagram"><i className="bx bxl-instagram"></i></a>}
              {social.github && <a href={social.github} className="google-plus"><i className="bx bxl-github"></i></a>}
              {social.linkedin && <a href={social.linkedin} className="linkedin"><i className="bx bxl-linkedin"></i></a>}
            </div>
          </div>

          <nav id="navbar" className="nav-menu navbar">
            <ul>
              <li data-aos="fade-right" data-aos-delay="100">
                <a href="/" className={`nav-link scrollto ${activeSection === 'home' ? 'active' : ''}`}>
                  <i className="bx bx-home"></i> <span>Home</span>
                </a>
              </li>
              <li data-aos="fade-right" data-aos-delay="200">
                <a href="/#about" className={`nav-link scrollto ${activeSection === 'about' ? 'active' : ''}`}>
                  <i className="bx bx-user"></i> <span>About</span>
                </a>
              </li>
              <li data-aos="fade-right" data-aos-delay="300">
                <a href="/#resume" className={`nav-link scrollto ${activeSection === 'resume' ? 'active' : ''}`}>
                  <i className="bx bx-file-blank"></i> <span>Resume</span>
                </a>
              </li>
              <li data-aos="fade-right" data-aos-delay="400">
                <a href="/#portfolio" className={`nav-link scrollto ${activeSection === 'portfolio' ? 'active' : ''}`}>
                  <i className="bx bx-book-content"></i> <span>Portfolio</span>
                </a>
              </li>
              {/* <li><a href="#services" className="nav-link scrollto"><i className="bx bx-server"></i> <span>Services</span></a></li>
        <li><a href="#contact" className="nav-link scrollto"><i className="bx bx-envelope"></i> <span>Contact</span></a></li> */}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
